/** 조기폐차 대상차량 확인(차량상태확인)서 - 별지 제3호 서식 */

const EarlyScrapVehicleClass = {
  AUTOMOBILE: 'AUTOMOBILE',
  CONSTRUCTION_MACHINERY: 'CONSTRUCTION_MACHINERY',
};

const EARLY_SCRAP_VEHICLE_CLASS_LABELS = {
  [EarlyScrapVehicleClass.AUTOMOBILE]: '자동차',
  [EarlyScrapVehicleClass.CONSTRUCTION_MACHINERY]: '건설기계',
};

const EarlyScrapConfirmationMethod = {
  ONLINE: 'ONLINE',
  ONSITE: 'ONSITE',
};

const EARLY_SCRAP_CONFIRMATION_METHOD_LABELS = {
  [EarlyScrapConfirmationMethod.ONLINE]:
    '온라인 대상차량확인 시스템(escar.or.kr)이용자: 시스템에 등록된 동영상으로 갈음',
  [EarlyScrapConfirmationMethod.ONSITE]:
    '현장 확인 : 사진 4매(전ㆍ후ㆍ좌ㆍ우면)',
};

/** 동일성 확인 1:일치 2:불일치 3:식별불가 */
const EarlyScrapIdentityResult = {
  MATCH: '1',
  MISMATCH: '2',
  UNIDENTIFIABLE: '3',
};

const EARLY_SCRAP_IDENTITY_RESULT_LABELS = {
  [EarlyScrapIdentityResult.MATCH]: '일치',
  [EarlyScrapIdentityResult.MISMATCH]: '불일치',
  [EarlyScrapIdentityResult.UNIDENTIFIABLE]: '식별불가',
};

/** 원동기/조향 1:가능 2:불가 */
const EarlyScrapOperationResult = {
  OK: '1',
  NG: '2',
};

const EARLY_SCRAP_OPERATION_RESULT_LABELS = {
  [EarlyScrapOperationResult.OK]: '가능',
  [EarlyScrapOperationResult.NG]: '불가',
};

/** 동력전달장치 1:가능 2:불가 3:전추진불가 */
const EarlyScrapPowerTransmissionResult = {
  OK: '1',
  NG: '2',
  FORWARD_REVERSE_NG: '3',
};

const EARLY_SCRAP_POWER_TRANSMISSION_RESULT_LABELS = {
  [EarlyScrapPowerTransmissionResult.OK]: '가능',
  [EarlyScrapPowerTransmissionResult.NG]: '불가',
  [EarlyScrapPowerTransmissionResult.FORWARD_REVERSE_NG]:
    '전진 또는 후진 불가',
};

/** 완충장치 등 1:양호 2:불량 */
const EarlyScrapConditionResult = {
  GOOD: '1',
  BAD: '2',
};

const EARLY_SCRAP_CONDITION_RESULT_LABELS = {
  [EarlyScrapConditionResult.GOOD]: '양호',
  [EarlyScrapConditionResult.BAD]: '불량',
};

/** 유압유 누출 1:양호 2:불량 3:단순불량(유압유부족) */
const EarlyScrapHydraulicResult = {
  GOOD: '1',
  BAD: '2',
  SIMPLE_BAD_OIL: '3',
};

const EARLY_SCRAP_HYDRAULIC_RESULT_LABELS = {
  [EarlyScrapHydraulicResult.GOOD]: '양호',
  [EarlyScrapHydraulicResult.BAD]: '불량',
  [EarlyScrapHydraulicResult.SIMPLE_BAD_OIL]: '단순 불량(유압유부족)',
};

/** 작동부 작동상태 1:양호 2:불량 3:단순불량 */
const EarlyScrapWorkingPartResult = {
  GOOD: '1',
  BAD: '2',
  SIMPLE_BAD: '3',
};

const EARLY_SCRAP_WORKING_PART_RESULT_LABELS = {
  [EarlyScrapWorkingPartResult.GOOD]: '양호',
  [EarlyScrapWorkingPartResult.BAD]: '불량',
  [EarlyScrapWorkingPartResult.SIMPLE_BAD]: '단순 불량',
};

/** 작동부 이상소음 1:양호 2:불량 3:단순불량(소음) */
const EarlyScrapWorkingPartNoiseResult = {
  GOOD: '1',
  BAD: '2',
  SIMPLE_BAD_NOISE: '3',
};

const EARLY_SCRAP_WORKING_PART_NOISE_RESULT_LABELS = {
  [EarlyScrapWorkingPartNoiseResult.GOOD]: '양호',
  [EarlyScrapWorkingPartNoiseResult.BAD]: '불량',
  [EarlyScrapWorkingPartNoiseResult.SIMPLE_BAD_NOISE]: '단순 불량(소음)',
};

/** 차체 외관 1:양호 2:불량 3:일부파손(찌그러짐) */
const EarlyScrapExteriorResult = {
  GOOD: '1',
  BAD: '2',
  PARTIAL_DAMAGE: '3',
};

const EARLY_SCRAP_EXTERIOR_RESULT_LABELS = {
  [EarlyScrapExteriorResult.GOOD]: '양호',
  [EarlyScrapExteriorResult.BAD]: '불량',
  [EarlyScrapExteriorResult.PARTIAL_DAMAGE]: '일부 파손(찌그러짐)',
};

/** 유리창 1:양호 2:불량 3:단순파손(일부파손) */
const EarlyScrapGlassResult = {
  GOOD: '1',
  BAD: '2',
  SIMPLE_DAMAGE: '3',
};

const EARLY_SCRAP_GLASS_RESULT_LABELS = {
  [EarlyScrapGlassResult.GOOD]: '양호',
  [EarlyScrapGlassResult.BAD]: '불량',
  [EarlyScrapGlassResult.SIMPLE_DAMAGE]: '단순 파손(일부파손)',
};

/** 타이어 1:양호 2:불량 3:단순불량(공기압부족) */
const EarlyScrapTireResult = {
  GOOD: '1',
  BAD: '2',
  SIMPLE_BAD_AIR: '3',
};

const EARLY_SCRAP_TIRE_RESULT_LABELS = {
  [EarlyScrapTireResult.GOOD]: '양호',
  [EarlyScrapTireResult.BAD]: '불량',
  [EarlyScrapTireResult.SIMPLE_BAD_AIR]: '단순 불량(공기압부족)',
};

/** 등화장치 1:설치 2:미설치 3:단순파손(일부깨짐) */
const EarlyScrapLightingResult = {
  INSTALLED: '1',
  NOT_INSTALLED: '2',
  SIMPLE_DAMAGE: '3',
};

const EARLY_SCRAP_LIGHTING_RESULT_LABELS = {
  [EarlyScrapLightingResult.INSTALLED]: '설치',
  [EarlyScrapLightingResult.NOT_INSTALLED]: '미설치',
  [EarlyScrapLightingResult.SIMPLE_DAMAGE]: '단순 파손(일부 깨짐)',
};

/** 정상가동여부 1:가 2:부 */
const EarlyScrapOperationalJudgment = {
  PASS: '1',
  FAIL: '2',
};

const EARLY_SCRAP_OPERATIONAL_JUDGMENT_LABELS = {
  [EarlyScrapOperationalJudgment.PASS]: '가 (합격/정상가동)',
  [EarlyScrapOperationalJudgment.FAIL]: '부 (불합격/가동불능)',
};

const EarlyScrapPhotoPosition = {
  FRONT: 'FRONT',
  REAR: 'REAR',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

const EARLY_SCRAP_PHOTO_POSITION_LABELS = {
  [EarlyScrapPhotoPosition.FRONT]: '전면',
  [EarlyScrapPhotoPosition.REAR]: '후면',
  [EarlyScrapPhotoPosition.LEFT]: '좌면',
  [EarlyScrapPhotoPosition.RIGHT]: '우면',
};

Object.freeze(EarlyScrapVehicleClass);
Object.freeze(EarlyScrapConfirmationMethod);
Object.freeze(EarlyScrapIdentityResult);
Object.freeze(EarlyScrapOperationResult);
Object.freeze(EarlyScrapPowerTransmissionResult);
Object.freeze(EarlyScrapConditionResult);
Object.freeze(EarlyScrapHydraulicResult);
Object.freeze(EarlyScrapWorkingPartResult);
Object.freeze(EarlyScrapWorkingPartNoiseResult);
Object.freeze(EarlyScrapExteriorResult);
Object.freeze(EarlyScrapGlassResult);
Object.freeze(EarlyScrapTireResult);
Object.freeze(EarlyScrapLightingResult);
Object.freeze(EarlyScrapOperationalJudgment);
Object.freeze(EarlyScrapPhotoPosition);

export {
  EarlyScrapVehicleClass,
  EARLY_SCRAP_VEHICLE_CLASS_LABELS,
  EarlyScrapConfirmationMethod,
  EARLY_SCRAP_CONFIRMATION_METHOD_LABELS,
  EarlyScrapIdentityResult,
  EARLY_SCRAP_IDENTITY_RESULT_LABELS,
  EarlyScrapOperationResult,
  EARLY_SCRAP_OPERATION_RESULT_LABELS,
  EarlyScrapPowerTransmissionResult,
  EARLY_SCRAP_POWER_TRANSMISSION_RESULT_LABELS,
  EarlyScrapConditionResult,
  EARLY_SCRAP_CONDITION_RESULT_LABELS,
  EarlyScrapHydraulicResult,
  EARLY_SCRAP_HYDRAULIC_RESULT_LABELS,
  EarlyScrapWorkingPartResult,
  EARLY_SCRAP_WORKING_PART_RESULT_LABELS,
  EarlyScrapWorkingPartNoiseResult,
  EARLY_SCRAP_WORKING_PART_NOISE_RESULT_LABELS,
  EarlyScrapExteriorResult,
  EARLY_SCRAP_EXTERIOR_RESULT_LABELS,
  EarlyScrapGlassResult,
  EARLY_SCRAP_GLASS_RESULT_LABELS,
  EarlyScrapTireResult,
  EARLY_SCRAP_TIRE_RESULT_LABELS,
  EarlyScrapLightingResult,
  EARLY_SCRAP_LIGHTING_RESULT_LABELS,
  EarlyScrapOperationalJudgment,
  EARLY_SCRAP_OPERATIONAL_JUDGMENT_LABELS,
  EarlyScrapPhotoPosition,
  EARLY_SCRAP_PHOTO_POSITION_LABELS,
};
